exports = module.exports = require("./../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".st0--3cQSlLDW{fill:#555}", ""]);

// exports
exports.locals = {
	"st0": "st0--3cQSlLDW"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[local]--[hash:base64:8]!./~/sass-loader!./src/components/sign_up/shared/close/styles.scss
// module id = 1041
// module chunks = 0